const optionPalette = [
  {
    stroke: "#38bdf8",
    fill: "rgba(56, 189, 248, 0.14)",
    gradientStart: "rgba(14, 165, 233, 0.78)",
    gradientMid: "rgba(56, 189, 248, 0.56)",
    gradientEnd: "rgba(186, 230, 253, 0.18)",
    sweep: "rgba(224, 242, 254, 0.34)"
  },
  {
    stroke: "#f97316",
    fill: "rgba(249, 115, 22, 0.14)",
    gradientStart: "rgba(234, 88, 12, 0.78)",
    gradientMid: "rgba(251, 146, 60, 0.56)",
    gradientEnd: "rgba(254, 215, 170, 0.18)",
    sweep: "rgba(255, 237, 213, 0.34)"
  },
  {
    stroke: "#a3e635",
    fill: "rgba(163, 230, 53, 0.14)",
    gradientStart: "rgba(132, 204, 22, 0.76)",
    gradientMid: "rgba(163, 230, 53, 0.54)",
    gradientEnd: "rgba(217, 249, 157, 0.18)",
    sweep: "rgba(247, 254, 231, 0.3)"
  },
  {
    stroke: "#f472b6",
    fill: "rgba(244, 114, 182, 0.14)",
    gradientStart: "rgba(236, 72, 153, 0.76)",
    gradientMid: "rgba(244, 114, 182, 0.54)",
    gradientEnd: "rgba(251, 207, 232, 0.18)",
    sweep: "rgba(252, 231, 243, 0.32)"
  }
];

export function getMarketOptionColors(index) {
  const palette = optionPalette[Math.abs(Number(index) || 0) % optionPalette.length];
  return {
    stroke: palette.stroke,
    fill: palette.fill,
    gradientStart: palette.gradientStart,
    gradientMid: palette.gradientMid,
    gradientEnd: palette.gradientEnd,
    sweep: palette.sweep
  };
}
